import { Link } from "@tanstack/react-router";
import { CartDrawer } from "./CartDrawer";
import { useEffect, useState } from "react";
import { Menu } from "lucide-react";
import {
  Sheet,
  SheetContent,
  SheetTrigger,
} from "@/components/ui/sheet";

const NAV = [
  { to: "/shop", label: "The Diamonds" },
  { to: "/quiz", label: "Find Your Stone" },
  { to: "/bespoke", label: "Bespoke" },
  { to: "/about", label: "House" },
  { to: "/knowledge-base", label: "Knowledge Base" },
  { to: "/contact", label: "Contact" },
] as const;

export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-40 border-b transition-colors duration-300 ${
        scrolled
          ? "border-hairline bg-background/85 backdrop-blur-md"
          : "border-transparent bg-background"
      }`}
    >
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-6 lg:px-12">
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button
              className="flex h-10 w-10 items-center justify-center -ml-2"
              aria-label="Open menu"
            >
              <Menu className="h-5 w-5" strokeWidth={1.25} />
            </button>
          </SheetTrigger>
          <SheetContent
            side="left"
            className="w-full max-w-sm border-r border-hairline bg-background p-0"
          >
            <div className="flex h-20 items-center px-8">
              <span className="font-serif text-xl tracking-[0.4em]">HOWDEN</span>
            </div>
            <nav className="flex flex-col px-8 pt-8">
              {NAV.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  onClick={() => setOpen(false)}
                  className="border-b border-hairline py-6 font-serif text-2xl font-light tracking-wide text-foreground/80 transition-colors hover:text-foreground"
                  activeProps={{ className: "text-foreground" }}
                >
                  {item.label}
                </Link>
              ))}
            </nav>
          </SheetContent>
        </Sheet>

        <Link
          to="/"
          className="absolute left-1/2 -translate-x-1/2 font-serif text-2xl tracking-[0.5em] md:text-3xl"
          onClick={() => setOpen(false)}
        >
          HOWDEN
        </Link>

        <div className="flex items-center gap-1">
          <CartDrawer />
        </div>
      </div>
    </header>
  );
}
